import { useCallback, useState } from "react";

import { Popover, Tooltip } from "antd";

import { RVButton, RVIconSizeOptions } from "@regal-voice/ui";

import { DiagnosticPanel } from "./DiagnosticPanel";
import { useSseEchoDiagnostic } from "./useSseEchoDiagnostic";

import styles from "./SseConnectionDiagnostic.module.scss";

type SseConnectionDiagnosticProps = {
    className?: string;
};

export function SseConnectionDiagnostic({ className }: SseConnectionDiagnosticProps): JSX.Element {
    const [open, setOpen] = useState(false);
    const diagnostic = useSseEchoDiagnostic(open);

    const handleOpenChange = useCallback((nextOpen: boolean) => {
        setOpen(nextOpen);
    }, []);

    return (
        <Popover
            content={<DiagnosticPanel active={open} diagnostic={diagnostic} />}
            placement="bottomRight"
            trigger={["click"]}
            open={open}
            onOpenChange={handleOpenChange}
            overlayClassName={styles.popover}
        >
            <Tooltip title="SSE Connection">
                <RVButton
                    aria-label="SSE connection diagnostic"
                    className={className}
                    data-testid="sse-diagnostic-button"
                    icon="globe"
                    iconSize={RVIconSizeOptions.DEFAULT}
                    shape="circle"
                    size="middle"
                />
            </Tooltip>
        </Popover>
    );
}
